import { Cell } from 'utils/data'
import { compareTimeStrings } from 'utils/timeSort'

type InfColumnType = 'text' | 'time' | 'number'

export const INF_DETAIL_COLUMN_TYPES = {
    orderNumber: 'text',
    infTime: 'time',
    infUnits: 'number',
    attemptedUnits: 'number',
    dpci: 'text',
    item: 'text',
    teamMember: 'text',
    totalMinutes: 'number',
} as const satisfies Record<string, InfColumnType>

export type InfDetailColumnId = keyof typeof INF_DETAIL_COLUMN_TYPES

export const isInfDetailColumnId = (id: string): id is InfDetailColumnId =>
    Object.prototype.hasOwnProperty.call(INF_DETAIL_COLUMN_TYPES, id)

const compareBy: Record<InfColumnType, (a: string, b: string) => number> = {
    text: (a, b) => a.localeCompare(b),
    time: compareTimeStrings,
    number: (a, b) => Number(a) - Number(b),
}

export const sortInfDetails = (
    rows: Cell[][],
    headings: Cell[],
    columnId: InfDetailColumnId,
    direction: 'asc' | 'desc',
): Cell[][] => {
    const columnIndex = headings.findIndex((heading) => heading.id === columnId)
    if (columnIndex < 0) return [...rows]

    const multiplier = direction === 'desc' ? -1 : 1
    const compare = compareBy[INF_DETAIL_COLUMN_TYPES[columnId]]

    return [...rows].sort(
        (first, second) =>
            compare(
                first[columnIndex]?.value ?? '',
                second[columnIndex]?.value ?? '',
            ) * multiplier,
    )
}
